import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import userManager from "../../utils/user-manager"
import * as userDetailActions from "../../state/actions/userDetailActions"
import SplashScreen from "../../routes/SplashScreen"
import { ROUTES } from "../../constants"

class LoginSplash extends Component {
  static propTypes = {
    user: PropTypes.shape({
      access_token: PropTypes.string,
      expired: PropTypes.bool,
      profile: PropTypes.shape({
        tt_user: PropTypes.object,
      }),
    }),
    userDetail: PropTypes.shape({
      authenticated: PropTypes.bool,
    }),
    setUserDetails: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: null,
    userDetail: { authenticated: false },
  }
  state = {
    loginRedirectRequired: false,
  }
  componentDidMount = () => {
    this.checkComponentIsMounted = true

    if (
      this.props.user === null ||
      this.props.user.expired ||
      (this.props.userDetail === null || this.props.userDetail.authenticated === false)
    ) {
      userManager
        .signinSilent()
        .then((user) => {
          if (this.checkComponentIsMounted) {
            if (user) {
              this.loadUserDetails(user.profile.tt_user)
            } else {
              this.setState({ loginRedirectRequired: true })
            }
          }
        })
        .catch(() => {
          if (this.checkComponentIsMounted) {
            this.setState({ loginRedirectRequired: true })
          }
        })
    } else {
      this.loadUserDetails(this.props.user.profile.tt_user)
    }
  }

  componentWillUnmount = () => {
    this.checkComponentIsMounted = false
  }

  loadUserDetails = (user) => {
    this.props.setUserDetails(true, user)
  }

  render() {
    return (
      <div>
        <SplashScreen />
        {this.state.loginRedirectRequired ? <Redirect to={ROUTES.auth.signInRequired} /> : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    userDetails: state.userDetail,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setUserDetails: (authenticated, user) =>
      dispatch(userDetailActions.setUserDetails(authenticated, user)),
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(LoginSplash)



// WEBPACK FOOTER //
// ./src/components/auth/LoginSplash.jsx